<script setup>
import {ref, defineExpose, computed, onMounted} from 'vue'
import jobFairUserService from "@/pages/user/services/jobFair/jobFairUserService";

const jobNotice = ref({});
const recruitmentHall = ref({});
const corp = ref({});
const hidden = ref(0);

const intvDays = ref([]); // 면접 가능일

// 채용공고
const setJobNotice = (value) => {
  jobNotice.value = value;
  // console.log(jobNotice.value);
  // ojfIntvDay();
}

// 특별채용 참가 정보
const setRecruitmentHall = (value) => {
  recruitmentHall.value = value;
  // console.log(record);
}

// 기업 정보
const setCorp = (value) => {
  corp.value = value;
  // console.log(corp.value);
}

// 정보 히든처리 필요 1  불필요 0
const setHidden  = (value) => {
  hidden.value = value;
}

defineExpose({
  setJobNotice,
  setRecruitmentHall,
  setHidden,
  setCorp,
})

const getFullUrl = (url) => {
  if (!url) return '#' // url이 없으면 기본 값
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return 'https://' + url
  }
  return url
}

// 면접 가능일 조회
const ojfIntvDay = async () => {
  await jobFairUserService.ojfIntvDay(jobNotice.value.ojfId)
      .then( async (res) => {
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          if (result !== null && result !== '') {
            const selectedDays = result.split(',').map(d => d.trim());

            intvDays.value = selectedDays.map(day => ({
              label: day,
              on: false
            }));
          }
        }
      }).catch( (error) =>  {
    console.log(error);
  });
}

// 면접 가능일 전체인지 확인 후 문구 표시
const allDays = computed(() => recruitmentHall.value.intvAbleDay.split(','))
const isAllSelected = computed(() => intvDays.value.length === allDays.value.length)

</script>

<template>
  <!-- s : 채용공고 -->
  <div class="resume-wrap">
    <div class="self-info word-break-all">
      <h1 class="text">
        <span :class="{'state01': jobNotice.jobNoticeStateGb === '01', 'state02': jobNotice.jobNoticeStateGb === '03'}">{{ $gbNameKR('JOB_NOTICE_STATE_GB', jobNotice.jobNoticeStateGb) }}</span>
        {{ jobNotice.jobName }}
      </h1>
    </div>
    <!-- s : 모집 분야 -->
    <section class="basic">
      <h2>모집 분야</h2>
      <dl>
        <dt>관심 카테고리</dt>
        <dd>
          <span v-if="jobNotice.interests">{{ jobNotice.interests }}</span>
          <span v-else>-</span>
        </dd>
      </dl>
      <dl>
        <dt>직무</dt>
        <dd>
          <span v-if="jobNotice.job">{{ jobNotice.job }}</span>
          <span v-else>-</span>
        </dd>
      </dl>
      <dl>
        <dt>모집분야명</dt>
        <dd>
          <span v-if="jobNotice.recruitArea">{{ jobNotice.recruitArea }}</span>
          <span v-else>-</span>
        </dd>
      </dl>
      <dl>
        <dt>모집 인원</dt>
        <dd>
          <span v-if="jobNotice.recruitCnt">{{ jobNotice.recruitCnt }}명</span>
          <span v-else>-</span>
        </dd>
      </dl>
    </section>
    <!-- e : 모집 분야 -->
    <!-- s : 지원 자격 / 근무 조건 -->
    <section>
      <h2>지원 자격 / 근무 조건</h2>
      <div class="list-wrapper">
        <dl>
          <dt>경력</dt>
          <dd>
            <span v-if="jobNotice.jobExperience">{{ jobNotice.jobExperience }}</span>
            <span v-else>-</span>
          </dd>
        </dl>
        <dl>
          <dt>근무지역</dt>
          <dd>
            <span v-if="jobNotice.workArea1">{{ jobNotice.workArea1 }} {{ jobNotice.workArea2 }}</span>
            <span v-else-if="jobNotice.workHomeYn === 'Y'">재택가능</span>
            <span v-else>-</span>
          </dd>
        </dl>
        <dl>
          <dt>학력</dt>
          <dd>
            <span v-if="jobNotice.schoolGb">{{ $gbNameKR('SCHOOL_GB', jobNotice.schoolGb) }}</span>
            <span v-else>-</span>
          </dd>
        </dl>
        <dl>
          <dt>근무형태</dt>
          <dd>
            <span v-if="jobNotice.workType">{{jobNotice.workType }}</span>
            <span v-else>-</span>
          </dd>
        </dl>
        <dl>
          <dt>우대사항(자격증)</dt>
          <dd>
            <span v-if="jobNotice.specialTreat">{{ jobNotice.specialTreat }}</span>
            <span v-else>-</span>
          </dd>
        </dl>
        <dl>
          <dt>급여</dt>
          <dd>
            <span v-if="jobNotice.salaryGb === '01'">
              {{ $gbNameKR('SALARY_GB', jobNotice.salaryGb) }}
            </span>
            <span v-else>
              {{ $gbNameKR('SALARY_GB', jobNotice.salaryGb) }}
              {{ jobNotice.salary }}만원
            </span>
          </dd>
        </dl>
      </div>
    </section>
    <!-- e : 지원 자격 / 근무 조건 -->
    <!-- s : 기타 요건 -->
    <section class="board-detail">
      <h2>기타 요건</h2>
      <div class="word-break-all body">
        <p class="text" v-if="jobNotice.note" v-html="jobNotice.note"></p>
        <span v-else>-</span>
      </div>
    </section>
    <!-- e : 기타 요건 -->
  </div>
  <!-- e : 채용공고 -->
  <!-- s : 채용 기간 및 방법 -->
  <div class="resume-wrap mt-sm">
    <div class="self-info">
      <h1>채용 기간 및 방법</h1>
    </div>
    <section>
      <dl>
        <dt>채용기간</dt>
        <dd class="word-break-all">
          <span>{{  $yyyymmdd(jobNotice.recruitStartYmd) }} ~ {{ $yyyymmdd(jobNotice.recruitEndYmd) }}</span>
        </dd>
      </dl>
      <dl>
        <dt>면접 방식</dt>
        <dd>
          <span v-if="jobNotice.intvGb">{{ $gbNameKR('INTV_GB', jobNotice.intvGb) }}</span>
          <span v-else>-</span>
        </dd>
      </dl>
      <dl>
        <dt>이력서양식</dt>
        <dd>
          <div v-if="jobNotice.fileYn">
            <div class="file" v-if="jobNotice.fileYn === 'Y'" v-for="corpResumeAttache in jobNotice.corpResumeAttaches" @click="$downloadForPrivate({fileName:corpResumeAttache.fileName, fileDir: corpResumeAttache.fileDir })">
              {{ corpResumeAttache.fileName }}
              <span v-if="corpResumeAttache.fileSize">({{ $fileSize(corpResumeAttache.fileSize) }})</span>
              <div class="red">
                <small>※ 회사의 이력서 양식을 다운로드 받아 작성하신 후 지원 바랍니다.</small>
              </div>
            </div>
            <div v-else>협회 이력서</div>
          </div>
          <div v-else>-</div>
        </dd>
      </dl>
    </section>
  </div>
  <!-- e : 채용 기간 및 방법 -->
  <!-- s : 기업 정보 -->
  <div class="resume-wrap mt-sm">
    <div class="self-info">
      <h1>기업 정보</h1>
    </div>
    <section>
      <div class="corp-wrap">
        <div class="img">
          <KSAImage :src="corp.ciImgDir" />
          <h2>{{ corp.corpName }}</h2>
        </div>
        <div class="list-wrapper">
          <dl>
            <dt>기업형태</dt>
            <dd>{{ $gbNameKR('CORP_GB', corp.corpGb)}}</dd>
          </dl>
          <dl>
            <dt>창립연월</dt>
            <dd>{{ $yyyymm(corp.foundYm) }}</dd>
          </dl>
          <dl>
            <dt>산업군</dt>
            <dd>{{ $gbNameKR('INDUSTRY_GB', corp.industryGb) }}</dd>
          </dl>
          <dl>
            <dt>사원수</dt>
            <dd>{{ $gbNameKR('EMPLOYEE_NUM_GB', corp.employeeNumGb) }}</dd>
          </dl>
          <dl>
            <dt>업종</dt>
            <dd>{{ corp.bizType }}</dd>
          </dl>
          <dl>
            <dt>매출액</dt>
            <dd>{{ $gbNameKR('SALES_AMT_GB', corp.salesAmtGb) }}</dd>
          </dl>
          <dl>
            <dt>대표자명</dt>
            <dd>{{ corp.ceoName }}</dd>
          </dl>
          <dl>
            <dt>상장여부</dt>
            <dd>
            <span v-if="corp.corpPublicYn === 'Y'">
              상장
              {{ $gbNameKR('CORP_PUBLIC_GB', corp.corpPublicGb) }}
            </span>
            <span v-else>
              비상장
            </span>
            </dd>
          </dl>
          <dl>
            <dt>사업장소재지</dt>
            <dd>{{ corp.residenceArea1 }} {{ corp.residenceArea2 }}</dd>
          </dl>
          <dl>
            <dt>홈페이지</dt>
            <dd><a :href="getFullUrl(corp.homeUrl)" target="_blank" rel="noopener noreferrer" class="link">{{ corp.homeUrl }}</a></dd>
          </dl>
        </div>
      </div>
    </section>
  </div>
  <!-- e : 기업 정보 -->
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.modal-body {
  .resume-wrap {
    background-color: $gray-thin_color;
    padding: 30px;
    .resume-title {
      border-bottom: 2px solid $black_color;
      @include font-size_xxl;
      font-weight: bold;
      text-align: center;
      padding: 0 20px 20px;
      margin-bottom: 20px;
      //background: #ffffff;
    }
    .board-detail {
      .body {
        border-bottom: 0;
        .text {
          padding: 0;
        }
      }
    }
    .self-info {
      border-bottom: 2px solid $black_color;
      h1 {
        display: flex;
        align-items: center;
        width: 100%;
        @include font-size_xl;
        margin-bottom: 10px;
        span {
          display: inline-block;
          width: 80px;
          text-align: center;
          background-color: $blue_color;
          color: #fff;
          font-size: 14px;
          border-radius: 8px;
          padding: 2px 0;
          margin-right: 10px;
          &.state01 { // 채용대기
            color: $blue_color;
            border: 1px solid $blue_color;
            background: transparent;
          }
          &.state02 {
            background: $gray_color;
            color: #ffffff80;
          }
        }
      }
      p {
        @include font-size_md;
        margin-bottom: 20px;
        span {
          position: relative;
          margin-left: 20px;
          padding-left: 20px;
          &:before {
            content: "";
            position: absolute;
            top: 50%;
            left: 0;
            width: 1px;
            height: 14px;
            background: $gray-regular_color;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
          }
          &:first-child {
            padding: 0;
            margin: 0;
            &:before {
              display: none;
            }
          }
        }
      }
    }
    section {
      border-bottom: 1px solid $black_color;
      padding: 30px 0;
      &:last-child {
        border-bottom: 0;
        padding: 30px 0;
      }
      &.basic {
        div {
          border-top: $border_line;
          padding-top: 30px;
          h2 {
            margin-bottom: 10px;
          }
          p {
            word-break: break-word;
          }
        }
      }
      &.army {
        h2 {
          color: $black_color;
        }
      }
      .corp-wrap {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: flex-start;
        width: 100%;
        .img {
          flex: 0.4 0 0; /* 0.4 비율 */
          padding-right: 40px;
          border-bottom: 0;
        }
        .list-wrapper {
          flex: 1 0 0; /* 남은 공간 자동 할당 */
          min-width: 0; /* 넘침 방지 */
          dl {
            dt {
              width: 120px;
            }
            dd {
              width: calc(100% - 120px);
            }
          }
        }
      }
      .list-wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: flex-start;
        dl {
          flex-basis: 50%;
        }
      }
      h2 {
        @include font-size_md;
        margin-bottom: 20px;
      }
      dl {
        display: flex;
        margin-bottom: 30px;
        &:last-child {
          margin-bottom: 0;
        }
        dt {
          width: 192px;
          color: $gray_color;
          b {
            display: block;
            color: $black_color;
            margin-bottom: 6px;
          }
        }
        dd {
          width: calc(100% - 192px);
          b {
            display: block;
            margin-bottom: 6px;
          }
          p {
            span {
              position: relative;
              padding-left: 10px;
              margin-left: 10px;
              &:before {
                content: "";
                position: absolute;
                top: 50%;
                left: 0;
                width: 1px;
                height: 10px;
                background: $gray-regular_color;
                -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
              }
            }
          }
          .file, .link {
            color: $blue_color;
            cursor: pointer;
          }
          .link {
            text-decoration: underline;
          }
        }
      }
      div {
        padding-bottom: 20px;
        border-bottom: $border_line;
        &:last-child {
          border-bottom: 0;
          padding-bottom: 0;
        }
        h3 {
          @include font-size_md;
          color: $gray_color;
          margin-top: 20px;
          margin-bottom: 6px;
        }
      }
    }
  }
}
</style>